import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "react-toastify/dist/ReactToastify.css";

/**
 * @dfinity/agent requires this. Can be removed once it's fixed
 */
if (typeof window !== "undefined") (window as any).global = window;
if (typeof window !== "undefined") {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById("root")
  );
} else {
  console.error("This is not rendering in a window");
  <div>This is not rendering in a window</div>;
}
